import "./silenceConsole";
import React from "react";
import { createRoot } from "react-dom/client";
import "./setupAxiosDev";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.REACT_APP_BASENAME || "/"}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
